import { concatBasePathWithPath } from 'common/router/utils';
import {
  CharityVettingUrlType,
  type CharityVettingUrlTypeValues,
  type OmittedLocalisedFlowProgress,
} from 'features/charity-vetting/types/charityVettingTypes';
import { FormattedMessage } from 'react-intl';

import msg from '../common-flow/components/navigation-bar/messages';
import { vettingPath } from '../common-flow/entries/path';

import { type StepName } from './formHandlers';

export const commonNavigationItems = {
  search: {
    stepLabel: <FormattedMessage {...msg.charityVettingNavItemSearch} />,
    id: CharityVettingUrlType.SEARCH as StepName,
    isCompleted: false,
    isActive: false,
    urlTypeId: [
      'search',
      'manual-contact-details',
      'contact-details',
      'legal-representative',
    ] as CharityVettingUrlTypeValues[],
    stepPathUrl: concatBasePathWithPath(vettingPath.searchPath, vettingPath.basePath),
  },
  socialAccounts: {
    stepLabel: <FormattedMessage {...msg.charityVettingNavItemSocialMedia} />,
    id: CharityVettingUrlType.SOCIAL_ACCOUNTS as StepName,
    isCompleted: false,
    isActive: false,
    urlTypeId: ['social-accounts'] as CharityVettingUrlTypeValues[],
    stepPathUrl: concatBasePathWithPath(vettingPath.socialAccountsPath, vettingPath.basePath),
  },
  reviewDetails: {
    stepLabel: <FormattedMessage {...msg.charityVettingNavItemReviewDetails} />,
    id: CharityVettingUrlType.REVIEW_DETAILS as StepName,
    isCompleted: false,
    isActive: false,
    urlTypeId: ['review-details'] as CharityVettingUrlTypeValues[],
    stepPathUrl: concatBasePathWithPath(vettingPath.reviewDetailsPath, vettingPath.basePath),
  },
};

export const progressChecker = (
  step: StepName,
  localisedFlowProgress:
    | OmittedLocalisedFlowProgress
    | { 'food-safety-question-three': boolean }
    | { 'association-registration': boolean },
) => {
  if (localisedFlowProgress && step in localisedFlowProgress) {
    return localisedFlowProgress[step as keyof typeof localisedFlowProgress];
  }
  return false;
};

export const matchCurrentPathNameToNavigationChange = (
  pathName: string,
  id: CharityVettingUrlTypeValues[],
) => {
  const normalizedPath = pathName.replace(/\/$/, '');
  const specificPathName = normalizedPath.substring(normalizedPath.lastIndexOf('/') + 1) || '';
  return !!id.find((item) => item === specificPathName);
};
